import { useCallback } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { isMarkActive, toggleMarkCommand } from '../utils/markUtils';
import { RTEToolbarButton } from '../components/StyledTextToolbarButton';
import { TextToolbarIcon } from 'rich-text-lib/components/editor/TextToolbarIcon';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import useDebouncedEditorStateContext from '../contexts/useDebouncedEditorStateContext';
import { StrikeIcon } from 'foundations-assets/icons/components/StrikeIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export const toggleStrike = toggleMarkCommand(schema => schema.marks.strikethrough);
export default function StrikeMark() {
  const {
    editorState,
    setEditorState
  } = useDebouncedEditorStateContext();
  const toggleStrikeMark = useCallback(e => {
    e.preventDefault();
    toggleStrike(editorState, tr => setEditorState(editorState.apply(tr)));
  }, [editorState, setEditorState]);
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hubspot-prosemirror.tooltips.strikethrough"
    }),
    children: /*#__PURE__*/_jsx(RTEToolbarButton, {
      onMouseDown: toggleStrikeMark,
      "data-test-id": "strikethrough",
      "aria-label": I18n.text('hubspot-prosemirror.tooltips.strikethrough'),
      selected: editorState && hasStrikethrough(editorState),
      children: /*#__PURE__*/_jsx(TextToolbarIcon, {
        icon: StrikeIcon
      })
    })
  });
}
function hasStrikethrough(state) {
  return isMarkActive(state, state.schema.marks.strikethrough);
}